import { render } from "./ShippingSettings.vue?vue&type=template&id=44a8a130&scoped=true"
import script from "./ShippingSettings.vue?vue&type=script&lang=js"
export * from "./ShippingSettings.vue?vue&type=script&lang=js"

import "./ShippingSettings.vue?vue&type=style&index=0&id=44a8a130&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44a8a130"]])

export default __exports__